import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentModel} from "../../angular/models/agent.model";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ServiceAreasAlerts} from "../../../service-areas/services/service-areas-alerts.service";

export class AgentServiceAreasCtrl implements IController {

  agent: AgentModel;
  preferences: any;

  private preferencesCopy: any;

  constructor(private agentRequests: AgentRequests, private serviceAreasAlerts: ServiceAreasAlerts, private $log, private bringozLoaderService: BringozLoaderService) {
  }

  $onInit() {
    // The copy is for the changes made by server and NOT UI;
    this.preferencesCopy = angular.copy(this.preferences);
  }

  onServiceAreaChange(updatedAreas) {
    this.preferencesCopy.priorityServiceAreas = _.map(updatedAreas, (area) => {
      return area.areaId;
    });
    this._updatePreferences()
  }


  private _updatePreferences() {
    this.bringozLoaderService.on();
    this.agentRequests.setAgentPreferences(this.preferencesCopy, this.agent.id)
      .then((updatedPreferences) => {
        this.serviceAreasAlerts.updateManySuccess();
        this.preferences = updatedPreferences;
        this.$onInit();
      })
      .catch((error) => {
        this.serviceAreasAlerts.updateManyError();
        this.$log.error('Failed go updated preferences @teamPreferences@_updatePreferences', error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentServiceAreas', {
    bindings: {
      agent: '<',
      preferences: '<'
    },
    template: require('./agent-service-areas.html').default,
    controller: AgentServiceAreasCtrl
  });
